const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://fenestro.cloud';
export const API = BASE_URL + '/api';
export const BASE = BASE_URL;
